import { useState } from 'react';

import _ from 'lodash';

import { useEffectSafeStrictMode } from 'hooks/useEffectSafeStrictMode';

import { fetchUploaderName } from './utils';

const useDocumentUploaderName = ({ companyId, userId, isEnabled }) => {
  const [resolved, setResolved] = useState(null);

  const isLookupNeeded = isEnabled && !_.isNil(companyId) && !_.isNil(userId);

  useEffectSafeStrictMode(() => {
    if (!isLookupNeeded) {
      return _.noop;
    }

    const request = { isActive: true };

    fetchUploaderName({ companyId, userId }).then(name => {
      if (request.isActive) {
        setResolved({ userId, name });
      }
    });

    return () => {
      request.isActive = false;
    };
  }, [companyId, userId, isLookupNeeded]);

  return isLookupNeeded && resolved?.userId === userId ? resolved.name : null;
};

export default useDocumentUploaderName;
